export default __webpack_public_path__ + "static/bentoSectionBg2Mob-b01132386db0dde0ea9cf3f345f15d50.webp";